module.exports = __webpack_public_path__ + "img/tree-md.95a2fc82.png";